import { Context, createContext } from 'react';

export interface IVpaasContext {
  isEnabled: boolean;
  producerTitle?: string;
}

export const VpaasContext: Context<IVpaasContext> = createContext<IVpaasContext>({
  isEnabled: false,
});
